import "core-js/modules/es.array.reverse.js";
var _class, _MapServerStratum, _class2, _ArcGisMapServerCatalogItem;
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import i18next from "i18next";
import uniqWith from "lodash-es/uniqWith";
import { computed, makeObservable, override, runInAction } from "mobx";
import { fromPromise } from "mobx-utils";
import moment from "moment";
import WebMercatorTilingScheme from "terriajs-cesium/Source/Core/WebMercatorTilingScheme";
import ArcGisMapServerImageryProvider from "terriajs-cesium/Source/Scene/ArcGisMapServerImageryProvider";
import URI from "urijs";
import TerriaError, { networkRequestError } from "../../../Core/TerriaError";
import createDiscreteTimesFromIsoSegments from "../../../Core/createDiscreteTimes";
import createTransformerAllowUndefined from "../../../Core/createTransformerAllowUndefined";
import filterOutUndefined from "../../../Core/filterOutUndefined";
import isDefined from "../../../Core/isDefined";
import loadJson from "../../../Core/loadJson";
import replaceUnderscores from "../../../Core/replaceUnderscores";
import { scaleDenominatorToLevel } from "../../../Core/scaleToDenominator";
import { setsAreEqual } from "../../../Core/setsAreEqual";
import Proj4Definitions from "../../../Map/Vector/Proj4Definitions";
import Reproject from "../../../Map/Vector/Reproject";
import CatalogMemberMixin from "../../../ModelMixins/CatalogMemberMixin";
import DiscretelyTimeVaryingMixin from "../../../ModelMixins/DiscretelyTimeVaryingMixin";
import MappableMixin from "../../../ModelMixins/MappableMixin";
import UrlMixin from "../../../ModelMixins/UrlMixin";
import ArcGisMapServerCatalogItemTraits from "../../../Traits/TraitsClasses/ArcGisMapServerCatalogItemTraits";
import { InfoSectionTraits } from "../../../Traits/TraitsClasses/CatalogMemberTraits";
import LegendTraits, { LegendItemTraits } from "../../../Traits/TraitsClasses/LegendTraits";
import { RectangleTraits } from "../../../Traits/TraitsClasses/MappableTraits";
import CreateModel from "../../Definition/CreateModel";
import LoadableStratum from "../../Definition/LoadableStratum";
import StratumOrder from "../../Definition/StratumOrder";
import createStratumInstance from "../../Definition/createStratumInstance";
import getToken from "../../getToken";
import proxyCatalogItemUrl from "../proxyCatalogItemUrl";
import MinMaxLevelMixin from "./../../../ModelMixins/MinMaxLevelMixin";
import proj4 from "proj4";
let MapServerStratum = (_class = (_MapServerStratum = class MapServerStratum extends LoadableStratum(ArcGisMapServerCatalogItemTraits) {
  constructor(_item, mapServer, allLayers, _legends, _token) {
    super();
    this._item = _item;
    this.mapServer = mapServer;
    this.allLayers = allLayers;
    this._legends = _legends;
    this._token = _token;
    makeObservable(this);
  }
  duplicateLoadableStratum(newModel) {
    return new MapServerStratum(newModel, this.mapServer, this.allLayers, this._legends, this._token);
  }
  static async load(item) {
    var _serviceMetadata$capa, _serviceMetadata$full, _serviceMetadata$full2, _serviceMetadata$full3;
    if (!isDefined(item.uri) || !isDefined(item.url)) {
      throw new TerriaError({
        title: i18next.t("models.arcGisMapServerCatalogItem.invalidUrlTitle"),
        message: i18next.t("models.arcGisMapServerCatalogItem.invalidUrlMessage")
      });
    }
    let token;
    if (isDefined(item.tokenUrl)) {
      token = await getToken(item.terria, item.tokenUrl, item.url);
    } else if (isDefined(item.token)) {
      token = item.token;
    }
    let serviceUri = getBaseURI(item);
    let layersUri = getBaseURI(item).segment("layers");
    let legendUri = getBaseURI(item).segment("legend");
    if (isDefined(token)) {
      serviceUri = serviceUri.addQuery("token", token);
      layersUri = layersUri.addQuery("token", token);
      legendUri = legendUri.addQuery("token", token);
    }

    // TODO: if tokenUrl, fetch and pass token as parameter
    const serviceMetadata = await getJson(item, serviceUri);
    if (!isDefined(serviceMetadata)) {
      throw networkRequestError({
        title: i18next.t("models.arcGisService.invalidServerTitle"),
        message: i18next.t("models.arcGisService.invalidServerMessage")
      });
    }
    const legendMetadata = await getJson(item, legendUri);
    let layers = [];

    // If this MapServer is a single fused map cache - we can't request individual layers
    // If it is not - we request layer metadata

    if (!(serviceMetadata.singleFusedMapCache && (_serviceMetadata$capa = serviceMetadata.capabilities) !== null && _serviceMetadata$capa !== void 0 && _serviceMetadata$capa.includes("TilesOnly"))) {
      const layersMetadataResponse = await getJson(item, layersUri);

      // Use the slightly more basic layer metadata
      if (isDefined(serviceMetadata.layers)) {
        layers = serviceMetadata.layers;
      }
      if (isDefined(layersMetadataResponse === null || layersMetadataResponse === void 0 ? void 0 : layersMetadataResponse.layers)) {
        layers = layersMetadataResponse.layers;
      }
      if (!isDefined(layers) || layers.length === 0) {
        throw networkRequestError({
          title: i18next.t("models.arcGisMapServerCatalogItem.noLayersFoundTitle"),
          message: i18next.t("models.arcGisMapServerCatalogItem.noLayersFoundMessage", item)
        });
      }
    }
    const stratum = new MapServerStratum(item, serviceMetadata, layers, legendMetadata, token);

    // Add any Proj4 definitions if necessary
    const epsgCode = (_serviceMetadata$full = (_serviceMetadata$full2 = serviceMetadata.fullExtent.spatialReference) === null || _serviceMetadata$full2 === void 0 ? void 0 : _serviceMetadata$full2.latestWkid) !== null && _serviceMetadata$full !== void 0 ? _serviceMetadata$full : (_serviceMetadata$full3 = serviceMetadata.fullExtent.spatialReference) === null || _serviceMetadata$full3 === void 0 ? void 0 : _serviceMetadata$full3.wkid;
    if (epsgCode && item.terria.configParameters.proj4ServiceBaseUrl) {
      await Reproject.checkProjection(item.terria.configParameters.proj4ServiceBaseUrl, "EPSG:".concat(epsgCode));
    }
    return stratum;
  }
  get token() {
    return this._token;
  }
  get maximumScale() {
    if (this._item.layersArray.length === 0) {
      return this.mapServer.maxScale;
    }
    return Math.min(...filterOutUndefined(this._item.layersArray.map(_ref => {
      let {
        maxScale
      } = _ref;
      return maxScale;
    })));
  }
  get layers() {
    /** Try to pull out MapServer layer from URL
     * eg https://exmaple.com/arcgis/rest/services/MapServer/{layer}
     */
    if (isDefined(this._item.uri)) {
      const lastSegment = this._item.uri.segment(-1);
      if (isDefined(lastSegment) && lastSegment.match(/\d+/)) {
        return lastSegment;
      }
    }
  }
  get name() {
    // single layer
    if (this._item.layersArray.length === 1 && this._item.layersArray[0].name && this._item.layersArray[0].name.length > 0) {
      return replaceUnderscores(this._item.layersArray[0].name);
    }

    // group of layers (or single fused map cache)
    else if (this.mapServer.documentInfo && this.mapServer.documentInfo.Title && this.mapServer.documentInfo.Title.length > 0) {
      return replaceUnderscores(this.mapServer.documentInfo.Title);
    } else if (this.mapServer.mapName && this.mapServer.mapName.length > 0) {
      return replaceUnderscores(this.mapServer.mapName);
    }
  }
  get dataCustodian() {
    if (this.mapServer.documentInfo && this.mapServer.documentInfo.Author && this.mapServer.documentInfo.Author.length > 0) {
      return this.mapServer.documentInfo.Author;
    }
  }
  get rectangle() {
    const rectangle = {
      west: Infinity,
      south: Infinity,
      east: -Infinity,
      north: -Infinity
    };

    // If we only have the summary layer info
    if (this._item.layersArray.length === 0 || !("extent" in this._item.layersArray[0])) {
      getRectangleFromLayer(this.mapServer.fullExtent, rectangle);
    } else {
      getRectangleFromLayers(rectangle, this._item.layersArray);
    }
    if (rectangle.west === Infinity) return;
    return createStratumInstance(RectangleTraits, rectangle);
  }
  get info() {
    var _singleLayer$copyrigh;
    // If we are requesting a single layer, use it to populate InfoSections
    // If we are requesting multiple layers - we only show MapServer metadata (not metadata per layer)
    const singleLayer = this._item.layersArray.length === 1 ? this._item.layersArray[0] : undefined;
    return filterOutUndefined([singleLayer ? createStratumInstance(InfoSectionTraits, {
      name: i18next.t("models.arcGisMapServerCatalogItem.dataDescription"),
      content: singleLayer.description
    }) : undefined, createStratumInstance(InfoSectionTraits, {
      name: i18next.t("models.arcGisMapServerCatalogItem.serviceDescription"),
      content: this.mapServer.description
    }), createStratumInstance(InfoSectionTraits, {
      name: i18next.t("models.arcGisMapServerCatalogItem.copyrightText"),
      content: (_singleLayer$copyrigh = singleLayer === null || singleLayer === void 0 ? void 0 : singleLayer.copyrightText) !== null && _singleLayer$copyrigh !== void 0 ? _singleLayer$copyrigh : this.mapServer.copyrightText
    })]);
  }
  get legends() {
    var _this$_legends;
    const layers = this._item.layersArray;
    const noDataRegex = /^No[\s_-]?Data$/i;
    const labelsRegex = /_Labels$/;
    let items = [];
    (((_this$_legends = this._legends) === null || _this$_legends === void 0 ? void 0 : _this$_legends.layers) || []).forEach(l => {
      var _l$legend;
      if (noDataRegex.test(l.layerName) || labelsRegex.test(l.layerName)) {
        return;
      }
      if (layers.length > 0 && !layers.find(layer => layer.id === l.layerId) && !layers.find(layer => layer.name === l.layerName)) {
        // layer not selected
        return;
      }
      (_l$legend = l.legend) === null || _l$legend === void 0 || _l$legend.forEach(leg => {
        const title = replaceUnderscores(leg.label !== "" ? leg.label : l.layerName);
        const dataUrl = "data:" + leg.contentType + ";base64," + leg.imageData;
        items.push(createStratumInstance(LegendItemTraits, {
          title,
          imageUrl: dataUrl,
          imageWidth: leg.width,
          imageHeight: leg.height
        }));
      });
    });
    items = uniqWith(items, (a, b) => a.imageUrl === b.imageUrl);
    return [createStratumInstance(LegendTraits, {
      items
    })];
  }

  /** Only used "pre-cached" tiles if we aren't requesting any specific layers
   * If the `layersArray` property is specified, we request individual dynamic layers and ignore the fused map cache.
   */
  get usePreCachedTilesIfAvailable() {
    // Checking tileInfo in MapServer metadata should be handled by cesium - but currently there is a bug in ArcGisMapServerImageryProvider
    if (!this.mapServer.tileInfo) return false;
    if (this._item.parameters) return false;
    return this._item.layersArray.length === 0 || !this._item.layers || setsAreEqual(this._item.layersArray.map(l => l.id), this.allLayers.map(l => l.id));
  }
}, _defineProperty(_MapServerStratum, "stratumName", "mapServer"), _MapServerStratum), _applyDecoratedDescriptor(_class.prototype, "maximumScale", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "maximumScale"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "layers", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "layers"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "name", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "name"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dataCustodian", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "dataCustodian"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "rectangle", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "rectangle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "info", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "info"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "legends", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "legends"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "usePreCachedTilesIfAvailable", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "usePreCachedTilesIfAvailable"), _class.prototype), _class);
StratumOrder.addLoadStratum(MapServerStratum.stratumName);
let ArcGisMapServerCatalogItem = (_class2 = (_ArcGisMapServerCatalogItem = class ArcGisMapServerCatalogItem extends UrlMixin(DiscretelyTimeVaryingMixin(MinMaxLevelMixin(CatalogMemberMixin(MappableMixin(CreateModel(ArcGisMapServerCatalogItemTraits)))))) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "_createImageryProvider", createTransformerAllowUndefined(timeParams => {
      const stratum = this.strata.get(MapServerStratum.stratumName);
      if (!isDefined(this.url) || !isDefined(stratum)) {
        return fromPromise(Promise.resolve(undefined));
      }
      const params = Object.assign({}, this.parameters);
      const currentTime = timeParams === null || timeParams === void 0 ? void 0 : timeParams.currentTime;
      if (currentTime !== undefined) {
        const windowDuration = this.windowDurationInMs(timeParams === null || timeParams === void 0 ? void 0 : timeParams.timeWindowDuration, timeParams === null || timeParams === void 0 ? void 0 : timeParams.timeWindowUnit);
        if (windowDuration !== undefined) {
          params.time = this.getTimeWindowQueryString(currentTime, windowDuration, timeParams === null || timeParams === void 0 ? void 0 : timeParams.isForwardTimeWindow);
        } else {
          params.time = currentTime;
        }
      }
      const maximumLevel = scaleDenominatorToLevel(this.maximumScale, true, false);
      const imageryProviderPromise = ArcGisMapServerImageryProvider.fromUrl(cleanAndProxyUrl(this, getBaseURI(this).toString()), {
        layers: this.layersArray.map(l => l.id).join(","),
        tilingScheme: new WebMercatorTilingScheme(),
        maximumLevel: maximumLevel,
        tileHeight: this.tileHeight,
        tileWidth: this.tileWidth,
        parameters: params,
        enablePickFeatures: this.allowFeaturePicking,
        usePreCachedTilesIfAvailable: this.usePreCachedTilesIfAvailable,
        mapServerData: stratum.mapServer,
        token: stratum.token,
        credit: this.attribution
      });
      return fromPromise(this.updateRequestImageAsync(imageryProviderPromise, false));
    }));
    makeObservable(this);
  }
  get typeName() {
    return i18next.t("models.arcGisMapServerCatalogItem.name");
  }
  get type() {
    return ArcGisMapServerCatalogItem.type;
  }
  async forceLoadMetadata() {
    const stratum = await MapServerStratum.load(this);
    runInAction(() => {
      this.strata.set(MapServerStratum.stratumName, stratum);
    });
  }
  forceLoadMapItems() {
    return Promise.all([this._currentImageryPromise, this._nextImageryPromise]).then(() => {});
  }
  get cacheDuration() {
    if (isDefined(super.cacheDuration)) {
      return super.cacheDuration;
    }
    return "1d";
  }
  get discreteTimes() {
    const mapServerStratum = this.strata.get(MapServerStratum.stratumName);
    if ((mapServerStratum === null || mapServerStratum === void 0 ? void 0 : mapServerStratum.mapServer.timeInfo) === undefined) return undefined;
    // Add union type - as `time` is always defined
    const result = [];
    createDiscreteTimesFromIsoSegments(result, new Date(mapServerStratum.mapServer.timeInfo.timeExtent[0]).toISOString(), new Date(mapServerStratum.mapServer.timeInfo.timeExtent[1]).toISOString(), undefined, this.maxRefreshIntervals);
    return result;
  }
  getCurrentTime() {
    const dateAsUnix = this.currentDiscreteTimeTag === undefined ? undefined : new Date(this.currentDiscreteTimeTag).getTime();
    return dateAsUnix;
  }
  get timeParams() {
    const currentTime = this.getCurrentTime();
    const timeWindowDuration = this.timeWindowDuration;
    const timeWindowUnit = this.timeWindowUnit;
    const isForwardTimeWindow = this.isForwardTimeWindow;
    const timeParams = {
      currentTime,
      timeWindowDuration,
      timeWindowUnit,
      isForwardTimeWindow
    };
    return timeParams;
  }
  get _currentImageryPromise() {
    const timeParams = this.timeParams;
    return this._createImageryProvider(timeParams);
  }
  get _currentImageryParts() {
    const imageryProviderObservablePromise = this._currentImageryPromise;

    // Return an ImageryPart when the the promise is fulfilled with a valid imageryProvider
    const imageryPart = imageryProviderObservablePromise.value instanceof ArcGisMapServerImageryProvider ? {
      imageryProvider: imageryProviderObservablePromise.value,
      alpha: this.opacity,
      show: this.show,
      clippingRectangle: this.clipToRectangle ? this.cesiumRectangle : undefined
    } : undefined;
    return imageryPart;
  }
  get _nextImageryPromise() {
    if (this.terria.timelineStack.contains(this) && !this.isPaused && this.nextDiscreteTimeTag) {
      const timeParams = this.timeParams;
      return this._createImageryProvider(timeParams);
    } else {
      return undefined;
    }
  }
  get _nextImageryParts() {
    const imageryProviderObservablePromise = this._nextImageryPromise;
    if (isDefined(imageryProviderObservablePromise)) {
      imageryProviderObservablePromise.case({
        fulfilled: imageryProvider => {
          // Disable feature picking for the next imagery layer
          if (imageryProvider instanceof ArcGisMapServerImageryProvider) imageryProvider.enablePickFeatures = false;
        }
      });
      // Return an ImageryPart when the the promise is fulfilled with a valid imageryProvider
      const imageryPart = imageryProviderObservablePromise.value instanceof ArcGisMapServerImageryProvider ? {
        imageryProvider: imageryProviderObservablePromise.value,
        alpha: 0.0,
        show: true,
        clippingRectangle: this.clipToRectangle ? this.cesiumRectangle : undefined
      } : undefined;
      return imageryPart;
    } else {
      return undefined;
    }
  }
  windowDurationInMs(rawTimeWindowDuration, timeWindowUnit) {
    if (rawTimeWindowDuration === undefined || rawTimeWindowDuration === 0 || timeWindowUnit === undefined) {
      return undefined;
    }
    const rawTimeWindowData = {};
    rawTimeWindowData[timeWindowUnit] = rawTimeWindowDuration;
    const duration = moment.duration(rawTimeWindowData).asMilliseconds();
    if (duration === 0) {
      return undefined;
    } else {
      return duration;
    }
  }
  getTimeWindowQueryString(currentTime, duration) {
    let isForward = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (isForward) {
      const toTime = Number(currentTime) + duration;
      return currentTime + "," + toTime;
    } else {
      const fromTime = Number(currentTime) - duration;
      return "" + fromTime + "," + currentTime;
    }
  }
  get mapItems() {
    const result = [];
    const current = this._currentImageryParts;
    if (current) {
      result.push(current);
    }
    const next = this._nextImageryParts;
    if (next) {
      result.push(next);
    }
    return result;
  }

  /** Return array of MapServer layers from `layers` trait (which is CSV of layer IDs) - this will only return **valid** MapServer layers.*/
  get layersArray() {
    const stratum = this.strata.get(MapServerStratum.stratumName);
    if (!stratum) return [];
    return filterOutUndefined(findLayers(stratum.allLayers, this.layers));
  }
}, _defineProperty(_ArcGisMapServerCatalogItem, "type", "esri-mapServer"), _ArcGisMapServerCatalogItem), _applyDecoratedDescriptor(_class2.prototype, "cacheDuration", [override], Object.getOwnPropertyDescriptor(_class2.prototype, "cacheDuration"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "discreteTimes", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "discreteTimes"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "timeParams", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "timeParams"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "_currentImageryPromise", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "_currentImageryPromise"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "_nextImageryPromise", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "_nextImageryPromise"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "_nextImageryParts", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "_nextImageryParts"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "mapItems", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "mapItems"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "layersArray", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "layersArray"), _class2.prototype), _class2);
export { ArcGisMapServerCatalogItem as default };
function getBaseURI(item) {
  const uri = new URI(item.url);
  const lastSegment = uri.segment(-1);
  if (lastSegment && lastSegment.match(/\d+/)) {
    uri.segment(-1, "");
  }
  return uri;
}
async function getJson(item, uri) {
  try {
    const response = await loadJson(proxyCatalogItemUrl(item, uri.addQuery("f", "json").toString()));
    return response;
  } catch (err) {
    console.log(err);
    return undefined;
  }
}

/* Given a comma-separated string of layer names, returns the layer objects corresponding to them. */
function findLayers(layers, names) {
  function findLayer(layers, id) {
    const idLowerCase = id.toLowerCase();
    let foundByName;
    for (let i = 0; i < layers.length; ++i) {
      const layer = layers[i];
      if (layer.id.toString() === id) {
        return layer;
      } else if (isDefined(layer.name) && layer.name.toLowerCase() === idLowerCase) {
        foundByName = layer;
      }
    }
    return foundByName;
  }
  if (!isDefined(names)) {
    // If a list of layers is not specified, we're using all layers.
    return layers;
  }
  return names.split(",").map(function (id) {
    return findLayer(layers, id);
  });
}
function updateBbox(extent, rectangle) {
  if (extent.xmin < rectangle.west) rectangle.west = extent.xmin;
  if (extent.ymin < rectangle.south) rectangle.south = extent.ymin;
  if (extent.xmax > rectangle.east) rectangle.east = extent.xmax;
  if (extent.ymax > rectangle.north) rectangle.north = extent.ymax;
}
export function getRectangleFromLayer(extent, rectangle) {
  var _extent$spatialRefere, _extent$spatialRefere2, _extent$spatialRefere3;
  const wkidCode = (_extent$spatialRefere = extent === null || extent === void 0 || (_extent$spatialRefere2 = extent.spatialReference) === null || _extent$spatialRefere2 === void 0 ? void 0 : _extent$spatialRefere2.latestWkid) !== null && _extent$spatialRefere !== void 0 ? _extent$spatialRefere : extent === null || extent === void 0 || (_extent$spatialRefere3 = extent.spatialReference) === null || _extent$spatialRefere3 === void 0 ? void 0 : _extent$spatialRefere3.wkid;
  if (isDefined(extent) && isDefined(wkidCode)) {
    if (wkidCode === 4326) {
      return updateBbox(extent, rectangle);
    }
    const wkid = "EPSG:" + wkidCode;
    if (!isDefined(Proj4Definitions[wkid])) {
      console.warn("No Proj4 definition for " + wkid);
      return;
    }
    const source = Proj4Definitions[wkid];
    const dest = "EPSG:4326";
    let p = proj4(source, dest, [extent.xmin, extent.ymin]);
    const west = p[0];
    const south = p[1];
    p = proj4(source, dest, [extent.xmax, extent.ymax]);
    const east = p[0];
    const north = p[1];
    return updateBbox({
      xmin: west,
      ymin: south,
      xmax: east,
      ymax: north
    }, rectangle);
  }
}
function getRectangleFromLayers(rectangle, layers) {
  layers.forEach(function (item) {
    if (item.extent) {
      getRectangleFromLayer(item.extent, rectangle);
    }
  });
}
function cleanAndProxyUrl(catalogItem, url) {
  return proxyCatalogItemUrl(catalogItem, cleanUrl(url));
}
function cleanUrl(url) {
  // Strip off the search portion of the URL
  const uri = new URI(url);
  uri.search("");
  return uri.toString();
}